import {useEffect, useState} from "react";
import {useInterval} from "react-use";
import {useStateWithDeps} from "use-state-with-deps";

const useCountdown = ({
  from,
  interval = 1,
  shouldStartCountdown = false,
  step = 1,
}: {
  from: number;
  interval?: number;
  shouldStartCountdown?: boolean;
  step?: number;
}) => {
  const [countdown, setCountdown] = useState(from);
  const [isRunning, setIsRunning] = useStateWithDeps(shouldStartCountdown, [shouldStartCountdown]);

  useInterval(
    () => {
      setCountdown(prev => Math.max(0, prev - step));
    },
    isRunning ? interval * 1000 : null,
  );

  const reset = ({shouldStartCountdown}: {shouldStartCountdown?: boolean}) => {
    setCountdown(from);
    setIsRunning(shouldStartCountdown || false);
  };

  const start = () => {
    setIsRunning(true);
  };

  const pause = () => {
    setIsRunning(false);
  };

  const resume = () => {
    setIsRunning(true);
  };

  const isCountdownFinished = countdown <= 0;

  useEffect(() => {
    if (countdown === 0) {
      pause();
    }
  }, [countdown, pause]);

  return {
    countdown,
    isCountdownFinished,
    start,
    pause,
    resume,
    reset,
    isRunning,
  };
};

export default useCountdown;
